import { RFIconProps } from "../types";

export default function MarkUpIcon(props: RFIconProps) {
	return (
		<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M1.6333 9.61333L4.02263 6.15066L6.83197 9.62266L10.92 2.436"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.4375 2.24933L11.4895 1.63333L12.0775 4.62"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
